import React from 'react';
import Icon from './Icon';
import './PaginationControls.css';

// Shared Prev/Next pager for server-paginated admin/super-admin tables (audit SA-08). Every page that already had
// pagination (Students, Tests, QuestionBank, Leaderboard, FeedbackInbox) hand-rolled its own — this is the one to use
// for anything new, so the control looks and behaves the same everywhere. Renders nothing when there's only one page.
const PaginationControls = ({ page, totalPages, onChange, total, className = '' }) => {
  if (!totalPages || totalPages <= 1) return null;
  return (
    <div className={`z-pagination ${className}`.trim()}>
      {typeof total === 'number' && <span className="z-pagination-total">{total} result{total !== 1 ? 's' : ''}</span>}
      <div className="z-pagination-controls">
        <button type="button" className="z-pagination-btn" onClick={() => onChange(page - 1)} disabled={page <= 1} aria-label="Previous page">
          <Icon name="chevron-left" size={16} />
        </button>
        <span className="z-pagination-status">Page {page} of {totalPages}</span>
        <button type="button" className="z-pagination-btn" onClick={() => onChange(page + 1)} disabled={page >= totalPages} aria-label="Next page">
          <Icon name="chevron-right" size={16} />
        </button>
      </div>
    </div>
  );
};

export default PaginationControls;
